import { Injectable } from "@angular/core";
import { lastValueFrom, Observable } from "rxjs";
import { DataResult, ICRUD } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_DISCOUNT_GROUP_VENDOR_GROUP_RELATION, GET_DISCOUNT_GROUP_VENDOR_GROUP_RELATION, GET_DISCOUNT_GROUP_VENDOR_GROUP_RELATIONS, SAVE_DISCOUNT_GROUP_VENDOR_GROUP_RELATION } from "../../../data/definitions/discount-group-vendor-group-relation.definition";
import { QueryResult } from "../../../data/query-result";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DeleteDiscountGroupVendorGroupRelationMutation, DeleteDiscountGroupVendorGroupRelationMutationVariables, DeletionResponse, DiscountGroupVendorGroupRelation, DiscountGroupVendorGroupRelationInput, DiscountGroupVendorGroupRelationSearchInput, GetDiscountGroupVendorGroupRelationQuery, GetDiscountGroupVendorGroupRelationQueryVariables, GetDiscountGroupVendorGroupRelationsQuery, GetDiscountGroupVendorGroupRelationsQueryVariables, SaveDiscountGroupVendorGroupRelationMutation, SaveDiscountGroupVendorGroupRelationMutationVariables } from "../../../generated/generated-types";

@Injectable({
    providedIn: 'root'
})
export class DiscountGroupVendorGroupRelationService extends BaseListService<DiscountGroupVendorGroupRelation> implements ICRUD<DiscountGroupVendorGroupRelation> {
    constructor(
        private baseDataService: BaseDataService,
        private systemService: SystemService,
    ) {
        super();
    }

    getData(searchInput?: DiscountGroupVendorGroupRelationSearchInput/*, options?: ICRUDOptions*/): Observable<DataResult<DiscountGroupVendorGroupRelation>> {
        return super.getData(searchInput);
    }

    getItems(searchInput: DiscountGroupVendorGroupRelationSearchInput): QueryResult<GetDiscountGroupVendorGroupRelationsQuery> {
        let fragment = GET_DISCOUNT_GROUP_VENDOR_GROUP_RELATIONS;

        return this.baseDataService.query<GetDiscountGroupVendorGroupRelationsQuery, GetDiscountGroupVendorGroupRelationsQueryVariables>(
            fragment, {
            input: searchInput
        });
    }

    getItem(id: string): QueryResult<GetDiscountGroupVendorGroupRelationQuery> {
        return this.baseDataService.query<GetDiscountGroupVendorGroupRelationQuery, GetDiscountGroupVendorGroupRelationQueryVariables>(
            GET_DISCOUNT_GROUP_VENDOR_GROUP_RELATION, {
            id: id
        });
    }

    async getItemData(id: string): Promise<DiscountGroupVendorGroupRelation> {
        return (await lastValueFrom(await this.getItem(id).mapSingle(x => x.getDiscountGroupVendorGroupRelation as DiscountGroupVendorGroupRelation)));
    }

    getItemStream(id: string): Observable<DiscountGroupVendorGroupRelation> {
        return this.getItem(id).mapStream(x => x.getDiscountGroupVendorGroupRelation as DiscountGroupVendorGroupRelation);
    }

    async saveItem(item: DiscountGroupVendorGroupRelationInput): Promise<DiscountGroupVendorGroupRelation> {
        // if (!item.type)
        //     item.type = DiscountGroupType.VENDORGROUP;

        let validated = await this.systemService.validateObject<DiscountGroupVendorGroupRelationInput>(item, "DiscountGroupVendorGroupRelationInput");

        let saved = await lastValueFrom(await this.baseDataService.mutate<SaveDiscountGroupVendorGroupRelationMutation, SaveDiscountGroupVendorGroupRelationMutationVariables>(
            SAVE_DISCOUNT_GROUP_VENDOR_GROUP_RELATION, {
            input: validated
        }));
        return saved.saveDiscountGroupVendorGroupRelation as DiscountGroupVendorGroupRelation;
    }

    async deleteItem(id: string): Promise<DeletionResponse> {
        let res = await lastValueFrom(await this.baseDataService.mutate<DeleteDiscountGroupVendorGroupRelationMutation, DeleteDiscountGroupVendorGroupRelationMutationVariables>(
            DELETE_DISCOUNT_GROUP_VENDOR_GROUP_RELATION, {
            id: id
        }));

        return res.deleteDiscountGroupVendorGroupRelation;
    }
}